import React from "react";

const CreateScheduledClass = React.lazy(() => import("./CreateScheduledClass"));
const Index = React.lazy(() => import("components/ScheduleClasses"));
const ScheduledClassDetails = React.lazy(() =>
  import("./ScheduledClassDetails")
);

export const classScheduledRoutes = [
  {
    path: "/admin/scheduleClasses",
    name: "Schedule Classes",
    element: <Index />,
  },
  {
    path: "/admin/scheduleClasses/create",
    name: "Create Scheduled Class",
    element: <CreateScheduledClass />,
  },
  {
    path: "/admin/scheduleClasses/update/:id?",
    name: "Create Scheduled Class",
    element: <CreateScheduledClass />,
  },
  {
    path: "/admin/scheduleClasses/:id?",
    name: "Scheduled Class",
    element: <ScheduledClassDetails />,
  },
];
